export const TOKEN_PAGE_ROUTE = '/';

export const CHAT_PAGE_PARAM = `id`;
export const CHAT_PAGE_ROUTE = `/:${CHAT_PAGE_PARAM}`;

export const RESPONSE_PAGE_PARAM = 'processId';
export const RESPONSE_PAGE_ROUTE = `/response/:${RESPONSE_PAGE_PARAM}`;

export const TEXT_PAGE_PARAM = 'textId';
export const TEXT_PAGE_ROUTE = `/text/:${TEXT_PAGE_PARAM}`;
